import axios from 'axios';

let http = axios.create({
  // baseURL: 'http://localhost:4001/api/',
  baseURL: 'https://api.huiyiji520.com/api/',
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
  transformRequest: [function (data) {
    let newData = '';
    for (let k in data) {
      // if (data.hasOwnProperty(k) === true) {
      if(Object.prototype.hasOwnProperty.call(data, k) === true){
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});

function apiAxios(method, url, params, response) {
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    response(res.data);
  }).catch(function (err) {
    console.log('网络异常，请稍后再试');
    console.log('url: '+ url + '; params: ' + JSON.stringify(params));
    console.log('err: ' + err)
  })
}

export default {
  get: function (url, params, response) {
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    return apiAxios('POST', url, params, response)
  },
  put: function (url, params, response) {
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    return apiAxios('DELETE', url, params, response)
  }
}
